import { EventDispatcher, IEvent } from 'Framework/Extensions/CoreJsExtensions';
import ISpecification from 'ts-specification/dist/ISpecification';

export class SpecificationCollection<T> {
    public add(specification: ISpecification<T>): boolean {
        if (this._specifications.includes(specification)) {
            return false;
        }

        this._specifications.push(specification);
        this._updateDispatcher.dispatch(this);

        return true;
    }

    public remove(specification: ISpecification<T>): boolean {
        const index = this._specifications.indexOf(specification);

        if (index < 0) {
            return false;
        }

        this._specifications.splice(index, 1);
        this._updateDispatcher.dispatch(this);

        return true;
    }

    public update(newValue: ISpecification<T>, oldValue: ISpecification<T>): boolean {
        const index = this._specifications.indexOf(oldValue);

        if (index < 0) {
            return false;
        }

        this._specifications.splice(index, 1, newValue);
        this._updateDispatcher.dispatch(this);

        return true;
    }

    public clear(): void {
        this._specifications.splice(0, this._specifications.length);
        this._updateDispatcher.dispatch(this);
    }

    public get specifications(): ReadonlyArray<ISpecification<T>> {
        return this._specifications as ReadonlyArray<ISpecification<T>>;
    }

    public get onUpdate(): IEvent {
        return this._updateDispatcher.toEvent();
    }

    private readonly _specifications: Array<ISpecification<T>> = [];
    private readonly _updateDispatcher: EventDispatcher = new EventDispatcher();
}
